import { useLazyQuery } from '@apollo/client'
import { GET_COUNTRY_LIST } from '../Queries'
import { Country } from '../../../types'

interface GetCountriesListQuery {
  getCountriesList: Country[]
}

export const useCountriesList = (): {
  countries: Country[]
  loading: boolean
  loadCountries: () => void
  shouldShowOptions: boolean
} => {
  const [getCountries, { data, loading }] = useLazyQuery<GetCountriesListQuery>(GET_COUNTRY_LIST, {
    fetchPolicy: 'network-only',
  })

  const countries = data?.getCountriesList || []
  const shouldShowOptions = countries.length > 0

  const loadCountries = () => {
    getCountries()
  }

  return {
    countries,
    loading,
    loadCountries,
    shouldShowOptions,
  }
}
